import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";

const ModalPopup = ({ selectedProject, onClose }) => {
    const [open, setOpen] = React.useState(false);

    console.log(selectedProject.data);
    const projectData = selectedProject.data;
    const projectScreenshots = [projectData.project_pilot_screenshots, projectData.project_full_screenshots];
    console.log(projectScreenshots);
    useEffect(() => {
        console.log(document.getElementById('closeBtn'));
    }, [])

    return (
        <div className="fade">
            <div className="modal">
                <div className="flex-row-container justify-space-between">
                    <div className="flex-item modal-title">{projectData.project_title}</div>
                    <div className="flex-item  txt-right thick link txt-30" onClick={onClose}><i className="fa fa-times"></i></div>
                </div>
                <div className="flex-row-container">
                    <div className="flex-item modal-preview mar-right-20">
                        <img src={projectData.project_pilot_screenshots[0]} width="100%" />
                    </div>
                    <div className="flex-2 ">
                        <p><strong>Overview:</strong></p>
                        <p>{projectData.project_short_desc}</p>
                        {/* <p>{projectData.project_long_desc}</p> */}
                        {
                            projectData.project_type.map((item) => {
                                return <span className="chip">{item} </span>
                            })
                        }
                        <div className="flex-row-container justify-space-between">
                            {projectScreenshots[0].map((file, index) => {
                                return (
                                    <div className='card flex-item-4 link'> 
                                      <div className="card-tn" onClick={
                                        () => {  
                                            let ele =  document.getElementById('image-preview');
                                            let innerHtml = '';
                                            innerHtml  = innerHtml + '<div style=\'position: absolute; right: 0; text-align:right; top: -15px\' > <span id=\'closeBtn\'><i class=\'fa fa-times\'></i></span></div>'
                                            innerHtml =  innerHtml + `<img src=${projectScreenshots[1][index]}  width='100%' />`
                                            ele.style.position = 'fixed';
                                            ele.style.display = 'block';
                                            ele.style.width = '100%';
                                            ele.style.inset = 0;
                                            ele.style.cursor = 'pointer';
                                            ele.style.zIndex = 99999;
                                            ele.style.outline = 0;
                                            ele.innerHTML = innerHtml;
                                            ele.addEventListener('click', () => { 
                                                console.log(ele);
                                                ele.innerHTML = '';
                                                ele.style.display = 'none';
                                            
                                            }); 
                                        }}> <img src={file} width="100%" /></div>
                                    </div>
                                )
                            })}
                        </div> 
                    </div>

                    {/* <div onClick={() => { setOpen(true) }}>Show Slides</div> */}
                    {/* <Lightbox
                        open={open}
                        close={() => setOpen(false)} 
                        slides={[
                            { 
                                alt: "image 1",
                                width: 3840,
                                height: 2560,
                                srcSet: [
                                    projectData.project_files.map((file) => {
                                        console.log(file);
                                        return [
                                            { src: file },
                                        ]
                                    })
                                ]
                                srcSet: [
                                   {src: 'https://firebasestorage.googleapis.com/v0/b/eastrosesun78.appspot.com/o/website%2Fecampus_pilot_1665510950040.jpg?alt=media&token=df659ceb-c090-4adb-8127-b4e2a7989f12'}, 
                                   {src: 'https://firebasestorage.googleapis.com/v0/b/eastrosesun78.appspot.com/o/website%2Fecampus_pilot_1665510950040.jpg?alt=media&token=df659ceb-c090-4adb-8127-b4e2a7989f12'}
                                ]
                            }
                        ]} 
                    /> */}
                </div>
            </div>
            <div id="image-preview" className="image-preview">

            </div>
        </div>
    )
}
export default ModalPopup;

